var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.96669C15.45 5.95836 15.3917 5.95836 15.3417 5.96669C14.1917 5.92502 13.275 4.98336 13.275 3.81669C13.275 2.62502 14.2334 1.66669 15.425 1.66669C16.6167 1.66669 17.575 2.63336 17.575 3.81669C17.5667 4.98336 16.65 5.92502 15.5 5.96669Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6417 12.0334C15.7834 12.225 17.0417 12.025 17.925 11.4334C19.1 10.65 19.1 9.3667 17.925 8.58337C17.0334 7.9917 15.7584 7.79169 14.6167 7.99169",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47503 5.96669C5.52503 5.95836 5.58336 5.95836 5.63336 5.96669C6.78336 5.92502 7.70002 4.98336 7.70002 3.81669C7.70002 2.62502 6.74169 1.66669 5.55003 1.66669C4.35836 1.66669 3.40002 2.63336 3.40002 3.81669C3.40836 4.98336 4.32503 5.92502 5.47503 5.96669Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 12.0334C5.19168 12.225 3.93335 12.025 3.05001 11.4334C1.87501 10.65 1.87501 9.3667 3.05001 8.58337C3.94168 7.9917 5.21668 7.79169 6.35834 7.99169",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.1917C10.45 12.1833 10.3916 12.1833 10.3416 12.1917C9.19163 12.15 8.27496 11.2083 8.27496 10.0417C8.27496 8.85 9.2333 7.89166 10.425 7.89166C11.6166 7.89166 12.575 8.85833 12.575 10.0417C12.5666 11.2083 11.65 12.1583 10.5 12.1917Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07498 14.8167C6.89998 15.6 6.89998 16.8833 8.07498 17.6667C9.40831 18.5583 11.5916 18.5583 12.925 17.6667C14.1 16.8833 14.1 15.6 12.925 14.8167C11.6 13.9333 9.40831 13.9333 8.07498 14.8167Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.0155a1b1fdaec8e5f4cbb53d7903515e.svg";
export { ForwardRef as ReactComponent };